var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heroes-pick-result"},[_vm._v(" Выбранный герой: "),(_vm.hero)?_c('Hero',{staticClass:"heroes-pick-result__hero",attrs:{"hero":_vm.hero}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }